import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useParams } from 'react-router';

import { useGetStudent } from 'api/hooks/private/users/students/GetStudent';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import { StudentProfileToolbar } from './components';
import Forms from './Tabs/Forms';
import Ledger from './Tabs/Ledger';
import Progress from './Tabs/Progress';
import Schedule from './Tabs/Schedule';
import StudentInformation from './Tabs/StudentInformation';
import UserActivity from './Tabs/UserActivity';

type StudentProfileTabs = 'info' | 'activity' | 'forms' | 'progress' | 'schedule' | 'ledger';

export function StudentProfile() {
  // get the student id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'info',
    serialize: String,
    deserialize: String,
  });

  // get the student information
  const student = useGetStudent({
    variables: {
      id: id ?? '',
    },
    enabled: !!id,
  });

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: StudentProfileTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer
      title={`${student.data?.first_name ?? ''} ${student.data?.middle_name ?? ''} ${student.data?.last_name ?? ''}`}
      slotProps={{
        header: {
          slots: {
            toolbar: () =>
              student.data ? (
                <StudentProfileToolbar
                  userId={student.data.id}
                  isActive={student.data.active}
                  needsOnboarding={student.data.needs_onboarding}
                  onboardingSentAt={student.data.onboarding_sent_at}
                  activatedAt={student.data.activated_at}
                />
              ) : null,
          },
        },
      }}
      // breadcrumbs={[
      //     {
      //         title: 'Title',
      //         path: 'Title'
      //     },
      //     {
      //         title: 'Title',
      //         path: 'Title'
      //     },
      // ]}
    >
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="info" label="Information" />
        <Tab value="activity" label="Activity" />
        <Tab value="forms" label="Forms" />
        <Tab value="progress" label="Progress" />
        <Tab value="schedule" label="Schedule" />
        <Tab value="ledger" label="Ledger" />
      </Tabs>

      {id && tabValue === 'info' && <StudentInformation studentId={id} />}

      {id && tabValue === 'activity' && <UserActivity userId={id} />}

      {id && tabValue === 'forms' && <Forms studentId={id} />}

      {id && tabValue === 'progress' && <Progress studentId={id} />}

      {id && tabValue === 'schedule' && <Schedule studentId={id} />}

      {id && tabValue === 'ledger' && <Ledger studentId={id} />}
    </PageContainer>
  );
}

export default StudentProfile;
